var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_c('button',{staticStyle:{"border":"none","background":"none","margin-right":"5px"}})])])
}]

export { render, staticRenderFns }